const initState = [];

const SprintsReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_SPRINTS':
            return action.data;
        case 'ADD_SPRINT':
            return state.concat(action.data);
        default:
            return state;
    }
};

export default SprintsReducer;